<ion-app dir="{{ textDir }}" class="scanner-hide">
  <ion-split-pane contentId="menu-content" when="false">
    <ion-menu contentId="menu-content" class="app-sidemenu" [attr.aria-label]="'SETTINGS' | translate">
      <ion-header>
        <ion-toolbar>
          <ion-row class="user-details-wrapper">
            <ion-col size="4">
              <app-aspect-ratio [ratio]="{ w: 1, h: 1 }">
                <div class="logoarea">
                  <img
                    class="user-avatar"
                    [src]="
                      sharedSvc?.drawerHeaderLogo || localImages.eprintitLogo
                    "
                    alt="Eprintit Logo"
                  />
                </div>
              </app-aspect-ratio>
            </ion-col>
            <ion-col class="user-info-wrapper" size="8">
              <h3 class="user-name">{{ "SETTINGS" | translate }}</h3>
            </ion-col>
          </ion-row>
          <!-- <ion-row class="user-stats-wrapper user-details-wrapper">
            <ion-col>
              <span class="user-stat-value">1553</span>
              <span class="user-stat-name">Following</span>
            </ion-col>
            <ion-col>
              <span class="user-stat-value">537</span>
              <span class="user-stat-name">Followers</span>
            </ion-col>
          </ion-row> -->
        </ion-toolbar>
      </ion-header>
      <ion-content data-cy="menuContent">
        <!-- <ion-list>
          <ion-list-header>
            <ion-label>USER ACCOUNTS</ion-label>
          </ion-list-header>
          <ion-menu-toggle
            autoHide="false"
            *ngFor="let p of appPages; let i = index"
          >
            <ion-item [routerLink]="p.url">
              <ion-icon
                slot="start"
                [name]="p.ionicIcon ? p.ionicIcon : ''"
                [src]="p.customIcon ? p.customIcon : ''"
              ></ion-icon>
              <ion-label>
                {{ p.title }}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list> -->
        <ion-list *ngIf="!isTermPage()">
          <ion-list-header role="presentation">
            <ion-label> {{ "USER_ACCOUNTS" | translate }}</ion-label>
          </ion-list-header>
          <!-- <ion-menu-toggle
            autoHide="true"
            
          > -->
          <ion-menu-toggle autoHide="false">
            <ion-item
              data-cy="addEditAccountMenuItem"
              (click)="navigateToAccounts()"
              (keydown.enter)="navigateToAccounts()"
              (keydown.space)="navigateToAccounts()"
              tabindex="1"
              [attr.aria-label]="'ADD_EDIT_ACCOUNTS' | translate"
              button="true"
            >
              <ion-icon slot="start" color="light" name="person" aria-hidden="true" role="presentation"></ion-icon>
              <ion-label color="light" class="ion-text-nowrap" aria-hidden="true">
                {{ "ADD_EDIT_ACCOUNTS" | translate }}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-item *ngIf="sharedSvc.showAccountOnlySection">
            <ion-icon slot="start" color="light" name="log-out" aria-hidden="true" role="presentation"></ion-icon>
            <ion-label color="light" class="ion-text-nowrap">
              {{ "ACCOUNT_ONLY" | translate }}
            </ion-label>
            <ion-toggle
              [attr.aria-label]="'ACCOUNT_ONLY' | translate"
              id="accountOnly"
              data-cy="accountOnlyToggle"
              [disabled]="loginAccountService.autoAccountAvail$ | async"
              checked="{{ sharedSvc.accountOnly }}"
              (ionChange)="accountOnlyHandler()"
              (keydown.enter)="accountOnlyHandler()"
              (keydown.space)="accountOnlyHandler()"
              slot="end"
            >
            </ion-toggle>
          </ion-item>
          <ion-menu-toggle
            autoHide="false"
            *ngIf="
              sharedSvc?.getCustomerDetails &&
              (loginAccountService.currentLocAtionAuthenticatedAccount$ | async).length
            "
          >
            <ion-item
              data-cy="viewBalanceMenuItem"
              (click)="navigateToSelectAccount('balance/view')"
              (keydown.enter)="navigateToSelectAccount('balance/view')"
              (keydown.space)="navigateToSelectAccount('balance/view')"
              tabindex="2"
              [attr.aria-label]="'VIEW_BALANCE' | translate"
              button="true"
            >
              <ion-icon slot="start" color="light" name="cash" aria-hidden="true" role="presentation"></ion-icon>
              <ion-label color="light" class="ion-text-nowrap" aria-hidden="true">
                {{ "VIEW_BALANCE" | translate }}
              </ion-label>
            </ion-item>
            <ion-item
              data-cy="addBalanceMenuItem"
              (click)="navigateToSelectAccount('balance/add')"
              (keydown.enter)="navigateToSelectAccount('balance/add')"
              (keydown.space)="navigateToSelectAccount('balance/add')"
              tabindex="3"
              [attr.aria-label]="'ADD_BALANCE' | translate"
              button="true"
            >
              <ion-icon slot="start" color="light" name="wallet" aria-hidden="true" role="presentation"></ion-icon>
              <ion-label color="light" class="ion-text-nowrap" aria-hidden="true">
                {{ "ADD_BALANCE" | translate }}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!-- </ion-menu-toggle> -->
        </ion-list>
        <ion-list *ngIf="cloudStorageToggle && !isTermPage()">
          <ion-list-header role="presentation">
            <ion-label> {{ "LINKED_STORAGE_ACCOUNTS" | translate }}</ion-label>
          </ion-list-header>
          <ion-item>
            <ion-label color="light" class="signin-toggle-note">
              {{'OPEN_SIGN_IN_WINDOW' | translate}}
            </ion-label>
          </ion-item>
          <!-- <ion-menu-toggle
            autoHide="true"
            
          > -->
          <ng-container *ngFor="let p of accountPages; let i = index">
            <ion-item *ngIf="p.isVisible" [attr.aria-label]="p.label">
              <ion-icon
                slot="start"
                color="light"
                [name]="p.ionicIcon ? p.ionicIcon : ''"
                aria-hidden="true"
                role="presentation"
              ></ion-icon>
              <ion-label color="light" class="ion-text-nowrap">
                {{ p.label }}
              </ion-label>
              <ion-toggle
                [attr.aria-label]="p.label + ' ' + ('OPEN_SIGN_IN_WINDOW' | translate)"
                [(ngModel)]="p.isEnabled"
                (ionChange)="switchToggle(p.title, p.isEnabled)"
                (keydown.enter)="switchToggle(p.title, p.isEnabled)"
                (keydown.space)="switchToggle(p.title, p.isEnabled)"
                slot="end"
              ></ion-toggle>
            </ion-item>
          </ng-container>
          <!-- </ion-menu-toggle> -->
        </ion-list>
        <ion-list>
          <ion-list-header role="presentation">
            <ion-label class="ion-text-nowrap">{{ "LANGUAGE" | translate }}</ion-label>
          </ion-list-header>
          <ion-menu-toggle autoHide="false">
            <ion-item
              data-cy="changeLanguageMenuItem"
              (click)="navigateToLanguages()"
              (keydown.enter)="navigateToLanguages()"
              (keydown.space)="navigateToLanguages()"
              tabindex="5"
              button="true"
            >
              <ion-icon
                color="light"
                slot="start"
                name="language-outline"
                aria-hidden="true"
              ></ion-icon>
              <ion-label color="light">
                {{ "CHANGE_LANGUAGE" | translate }}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
        <ion-list>
          <ion-list-header role="presentation">
            <ion-label class="ion-text-nowrap">{{ "HELP" | translate }}</ion-label>
          </ion-list-header>
          <ion-menu-toggle autoHide="false">
            <ion-item
              [attr.aria-label]="'CONTACT_SUPPORT' | translate"
              href="mailto:support@eprintit.com?subject={{
                deviceInfo ? deviceInfo.model : ''
              }} application support&body={{
                'APPLICATION_VERSION' | translate
              }}: {{ appVersion }}%0D%0A {{ 'DEVICE_MODEL' | translate }}: {{
                deviceInfo ? deviceInfo.model : ''
              }}%0D%0A {{ 'OS_VERSION' | translate }}: {{
                deviceInfo ? deviceInfo.osVersion : ''
              }}"
              tabindex="6"
              button="true"
            >
              <ion-icon
                color="light"
                slot="start"
                name="help-buoy-outline"
                aria-hidden="true"
                role="presentation"
              ></ion-icon>
              <ion-label color="light" class="ion-text-nowrap">
                {{ "CONTACT_SUPPORT" | translate }}
              </ion-label>
            </ion-item>
            <ion-item data-cy="aboutMenuItem" (click)="navigateToAbout()" [attr.aria-label]="'ABOUT' | translate" tabindex="7" button="true" (keydown.enter)="navigateToAbout()" (keydown.space)="navigateToAbout()">
              <ion-icon
                color="light"
                slot="start"
                name="information-circle-outline"
                aria-hidden="true"
                role="presentation"
              ></ion-icon>
              <ion-label color="light" class="ion-text-nowrap" aria-hidden="true"> {{ "ABOUT" | translate }} </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="menu-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
